import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner page-wrapper">
        <span className="footer-text">
          Mediaxone Platform designed and developed by{' '}
          <a
            href="https://cloudxier.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Cloudxier
          </a>
        </span>
      </div>
    </footer>
  );
}
